// Copyright (c) 2016 Deere & Company

import './maintenance-plan-item.scss';
import React, {PropTypes} from 'react';
import MaintenanceInterval from './maintenance-interval';
import MaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/maintenance-plan';

const MaintenancePlanItem = ({maintenancePlan}) => {

    const maintenanceIntervalList = maintenancePlan.intervals.map(maintenanceInterval =>
        <MaintenanceInterval
            key={maintenanceInterval.number}
            maintenanceInterval={maintenanceInterval}
            uom={maintenancePlan.uom}
        />
    );

    return (

        <div className='maintenance-plan-item-header'>
            <span className='maintenance-plan-item-name'>
                {maintenancePlan.name}
            </span>
            {maintenanceIntervalList}
        </div>

    );

};

MaintenancePlanItem.displayName = 'MaintenancePlanItem';
MaintenancePlanItem.propTypes = {
    maintenancePlan: PropTypes.instanceOf(MaintenancePlan).isRequired
};

export default MaintenancePlanItem;



// WEBPACK FOOTER //
// ./src/product/details/components/maintenance-plan-item.js